/**
 * Hallyu4U Enterprise API Configuration
 * All API keys and configurations for the theme
 * This file contains all necessary API configurations
 */

window.Hallyu4UConfig = {
  // Form Builder Integration
  formBuilder: {
    appId: 'powerful-form-builder',
    forms: {
      weBuyWeShip: 'we-buy-we-ship-form',
      youBuyWeShip: 'you-buy-we-ship-form',
      customsClearance: 'customs-clearance-form',
      returnRequest: 'return-request-form'
    }
  },

  // API Endpoints
  endpoints: {
    tracking: '/api/tracking',
    shipping: '/api/shipping',
    warehouse: '/api/warehouse',
    dashboard: '/api/dashboard',
    submissions: '/api/submissions',
    consolidation: '/api/consolidation'
  },

  // Cache Settings
  cache: {
    ttl: 3600, // 1 hour in seconds
    trackingTtl: 300, // 5 minutes for tracking updates
    shippingRatesTtl: 86400 // 24 hours for shipping rates
  },

  // Feature Flags
  features: {
    realTimeTracking: true,
    autoConsolidation: true,
    photoService: true,
    qualityInspection: true,
    expressCheckout: true,
    multiCurrency: true,
    loyaltyProgram: true
  },

  // Supported Carriers
  carriers: {
    korean: [
      { slug: 'cj-korea', name: 'CJ Logistics', tracking: /^[0-9]{10,12}$/ },
      { slug: 'hanjin', name: 'Hanjin Express', tracking: /^[0-9]{10,14}$/ },
      { slug: 'lotte', name: 'Lotte Global Logistics', tracking: /^[0-9]{10,12}$/ },
      { slug: 'korea-post', name: 'Korea Post', tracking: /^[A-Z]{2}[0-9]{9}KR$/ },
      { slug: 'gs-postbox', name: 'GS Postbox', tracking: /^[0-9]{12,14}$/ },
      { slug: 'cu-post', name: 'CU Post', tracking: /^[0-9]{10,12}$/ },
      // 홍대 매장 직접 접수 — 운송장 없음
      { slug: 'hongdae', name: 'Hongdae Store (drop-off)', tracking: /^$/ }
    ],
    international: [
      { slug: 'fedex', name: 'FedEx', tracking: /^[0-9]{12,22}$/ },
      { slug: 'dhl', name: 'DHL', tracking: /^[0-9]{10,11}$/ },
      { slug: 'ups', name: 'UPS', tracking: /^1Z[A-Z0-9]{16}$/ },
      { slug: 'ems', name: 'EMS', tracking: /^[A-Z]{2}[0-9]{9}[A-Z]{2}$/ },
      { slug: 'k-packet', name: 'K-Packet', tracking: /^[A-Z]{2}[0-9]{9}KR$/ }
    ]
  },

  // Initialize configuration
  init: function() {
    // Set up global API instances
    this.setupAPIs();

    // Initialize tracking
    this.initializeTracking();

    // Setup form handlers
    this.setupFormHandlers();
  },

  // Setup API instances
  setupAPIs: function() {},

  // Initialize tracking systems
  initializeTracking: function() {
    if (this.features.realTimeTracking) {
      // Initialize WebSocket or polling
    }
  },

  // Setup form handlers
  setupFormHandlers: function() {
    // Setup We Buy We Ship form
    const weBuyForm = document.getElementById('we-buy-form');
    if (weBuyForm) {
    }

    // Setup You Buy We Ship form
    const youBuyForm = document.getElementById('you-buy-form');
    if (youBuyForm) {
    }
  },

  // Utility functions
  utils: {
    // Validate tracking number
    validateTracking: function(trackingNumber, carrier) {
      const allCarriers = [...Hallyu4UConfig.carriers.korean, ...Hallyu4UConfig.carriers.international];
      const carrierInfo = allCarriers.find(c => c.slug === carrier);

      if (carrierInfo && carrierInfo.tracking) {
        return carrierInfo.tracking.test(trackingNumber);
      }

      return true; // Default to valid if no pattern
    },

    // Format currency
    formatCurrency: function(amount, currency = 'USD') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format(amount);
    },

    // Calculate shipping estimate
    calculateShipping: function(weight, method, destination) {
      // Basic calculation logic
      const rates = {
        express: { base: 25, perKg: 15 },
        standard: { base: 15, perKg: 8 },
        economy: { base: 10, perKg: 5 }
      };

      const rate = rates[method] || rates.standard;
      return rate.base + (weight * rate.perKg);
    }
  }
};

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => Hallyu4UConfig.init());
} else {
  Hallyu4UConfig.init();
}